import React from 'react';

class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let {
            children
        } = this.props;
        return (
            <span className = { `marketkit-button-wrapper-content` }>
                { children }
            </span>
        );
    }
}

export default Content;